import React from 'react';

import ated4KidsLogo from '../images/organizers/ated4kids_logo_no_border.png';
import codeLoungeLogo from '../images/organizers/codelounge-logo.png';
import luganoLivingLabLogo from '../images/organizers/lugano-living-lab-logo.png';
// import usiLogo from './../images/organizers/usi-logo.png';
import siLogo from '../images/organizers/si-logo.png';

import organizerLogosStyles from './OrganizerLogos.module.css';

interface ILogoData {
  image: any;
  imageAlt: string;
  href: string;
  id: string;
}

export const logoData: ILogoData[] = [
  {
    image: codeLoungeLogo,
    imageAlt: 'CodeLounge logo',
    href: 'https://codelounge.si.usi.ch',
    id: 'codelounge'
  },
  // {
  //   image: usiLogo,
  //   imageAlt: 'USI logo',
  //   href: 'https://usi.ch'
  // },
  {
    image: siLogo,
    imageAlt: 'Software Institute logo',
    href: 'https://si.usi.ch',
    id: 'si'
  },
  {
    image: ated4KidsLogo,
    imageAlt: 'Ated for Kids logo',
    href: 'https://www.ated.ch/progetto_ated4kids.php',
    id: 'ated'
  },
  {
    image: luganoLivingLabLogo,
    imageAlt: 'Lugano Living Lab logo',
    href: 'https://www.luganolivinglab.ch/',
    id: 'livinglab'
  }
];

const OrganizerLogos = () => (
  <div
    className={`organizer-logo-background ${organizerLogosStyles.organizerLogoBackground}`}
  >
    {}

    <div
      className={`organizer-logo-container ${organizerLogosStyles.organizerLogoContainer}`}
    >
      {logoData.map((data, index) => (
        <a
          key={index}
          className={`organizer-logo-link ${organizerLogosStyles.organizerLogoLink}`}
          href={data.href}
          target="_blank"
          rel="noopener noreferrer"
          id={organizerLogosStyles[data.id]}
        >
          <img
            className={`organizer-logo-image ${organizerLogosStyles.organizerLogoImage}`}
            src={data.image}
            alt={data.imageAlt}
          />
        </a>
      ))}
    </div>
  </div>
);

export default OrganizerLogos;
